{
    "types": [
        {
            "id": "CoastalStates",
            "alt-label": "All States",
            "label": "States",
            "fipsTypes": [
                "state"
            ],
            "description": [
                { 
                    "type": "text",
                    "value": "All states that are directly adjacent to the open ocean or the Great Lakes, as well as Washington DC, American Samoa, Guam, the Northern Mariana Islands, Puerto Rico, and US Virgin Islands."
                }
            ]
        },
        {
            "id": "StateCoastal",
            "label": "Coastal Shoreline Portion of States",
            "fipsTypes": [
                "state"
            ],
            "description": [
                { 
                    "type": "text",
                    "value": "A state by state aggregation of all Coastal Shoreline Counties in states that are directly adjacent to the open ocean or the Great Lakes, as well as Washington DC, American Samoa, Guam, the Northern Mariana Islands, Puerto Rico, and US Virgin Islands."
                }
            ]
        },
        {
            "id": "ShorelineCounties",
            "label": "Coastal Shoreline Counties",
            "fipsTypes": [
                "county"
            ],
            "description": [
                { 
                    "type": "text",
                    "value": "A county is considered a Coastal Shoreline County if it is directly adjacent to the open ocean, major estuaries, or the Great Lakes. These counties are considered to be most directly affected by issues pertaining to the coast. "
                },
                { 
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/qrt-coastal-county-definitions.pdf",
                    "text": "Go here"
                },
                { 
                    "type": "text",
                    "value": " for more information"
                }
            ]
        },
        {
            "id": "WatershedCounties",
            "label": "Coastal Watershed Counties",
            "fipsTypes": [
                "county"
            ],
            "description": [
                { 
                    "type": "text",
                    "value": "A county is considered a Coastal Watershed County if one of the following criteria is met: (1) at a minimum, 15 percent of the county’s total land area is located within a coastal watershed or (2) a portion of, or an entire county accounts for at least 15 percent of a coastal watershed. The 15-percent rule was selected as an appropriate level for capturing counties with a significant impact on coastal and ocean resources. "
                },
                { 
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/qrt-coastal-county-definitions.pdf",
                    "text": "Go here"
                },
                { 
                    "type": "text",
                    "value": " for more information"
                }
            ]
        },
        {
            "id": "CoastalWatershedStates",
            "label": "Coastal Watershed Portion of States",
            "fipsTypes": [
                "state"
            ],
            "description": [
                { 
                    "type": "text",
                    "value": "A state-by-state aggregation of all Coastal Watershed Counties within each coastal state. A county is considered a Coastal Watershed County if one of the following criteria is met: (1) at a minimum, 15 percent of the county’s total land area is located within a coastal watershed or (2) a portion of, or an entire county accounts for at least 15 percent of a coastal watershed. The 15-percent rule was selected as an appropriate level for capturing counties with a significant impact on coastal and ocean resources."
                },
                { 
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/qrt-coastal-county-definitions.pdf",
                    "text": " Go here"
                },
                { 
                    "type": "text",
                    "value": " for more information"
                }
            ]
        },
        {
            "id": "ENOW",
            "label": "Ocean Economy Geographies",
            "fipsTypes": [
                "region", "state", "county"
            ],
            "description": [
                { 
                    "type": "text",
                    "value": "Ocean and Great Lakes Economy "
                },
                { 
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/enow-counties-list.pdf",
                    "text": "data is available for"
                },
                {
                    "type": "text",
                    "value": " approximately 400 coastal counties, 30 coastal states, 8 regions, and the nation."
                }
            ]
        },
        {
            "id": "OpenENOW",
            "label": "Open Ocean Economy Estimates",
            "fipsTypes": [
                "region", "state"
            ],
            "description": [
                { 
                    "type": "text",
                    "value": "For more information, see the data documentation."
                },
                { 
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/enow-counties-list.pdf",
                    "text": ""
                },
                {
                    "type": "text",
                    "value": " Data is available for approximately 30 coastal states, 8 regions, and the nation."
                }
            ]
        }
    ]
}